import { createStore, getActionIds } from '../../helpers/redux';
import Immutable from 'immutable';

import { ElementTypeActions } from '../../actions/elementType';
import { RenameElementTypeMetaPropertyActions } from '../../actions/forms/renameElementTypeMetaProperty';
import { ProjectActions } from '../../actions/project';

const projectActions = getActionIds(ProjectActions);
const elementTypeActions = getActionIds(ElementTypeActions);
const renameElementTypeMetaPropertyActions = getActionIds(
  RenameElementTypeMetaPropertyActions,
);

const initialState = Immutable.fromJS({
  form: {},
  currentElementType: null,
  activeProp: null,
  metaKey: null,
  submitting: false,
  notifications: {},
  propType: 'String',
});

export const renameElementTypeMetaPropForm = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },
  // [elementTypeActions.renameElementType.success]: (state, action) => {
  //   return state.merge({
  //     notifications: {
  //       error: [{
  //         message: action.error[Object.keys(action.error)[0]][0]
  //       }]
  //     }
  //   });
  // },

  [elementTypeActions.renameElementType.failure]: (state, action) => {
    return state.merge({
      notifications: {
        error: [
          {
            message: action.error[Object.keys(action.error)[0]][0],
          },
        ],
      },
    });
  },

  [renameElementTypeMetaPropertyActions.setActiveProperty]: (state, action) => {
    return state.merge({
      form: { elementTypeMetaPropName: action.prop.metaKey },
      currentElementType: action.prop.elementTypeId,
      activeProp: action.prop.prop,
      metaKey: action.prop.metaKey,
    });
  },

  [renameElementTypeMetaPropertyActions.updateFormOnChange]: (
    state,
    action,
  ) => {
    return state.merge({
      form: action.form,
    });
  },

  [renameElementTypeMetaPropertyActions.dismissNotices]: (state, action) => {
    return state.merge({
      notifications: {},
    });
  },
});



// WEBPACK FOOTER //
// ./src/reducers/forms/renameElementTypeMetaProperty.js